<template>
    <v-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" max-width="480"
        persistent @keydown.esc="chiudi">
        <v-card>
            <v-card-title class="d-flex align-center">
                <v-icon class="mr-2">mdi-pencil</v-icon>
                <div>
                    <div>{{ titolo }}</div>
                    <div v-if="sottotitolo" class="text-caption text-medium-emphasis font-weight-regular">
                        {{ sottotitolo }}
                    </div>
                </div>
            </v-card-title>

            <v-card-text>
                <v-alert v-if="errore" type="error" variant="tonal" density="comfortable" class="rounded-lg mb-3"
                    closable @click:close="errore = null">
                    {{ errore }}
                </v-alert>

                <v-text-field v-if="dataModificabile" v-model="form.dataEsecuzione" type="date"
                    :label="etichettaData" :max="oggiIso" :rules="[v => !!v || 'Campo obbligatorio']"
                    :hint="avvisoData" :persistent-hint="!!avvisoData" class="mb-3" />

                <v-textarea v-model="form.note" :label="etichettaNote" rows="4" />
            </v-card-text>

            <v-card-actions>
                <v-spacer />
                <v-btn variant="text" @click="chiudi">Annulla</v-btn>
                <v-btn color="primary" :loading="salvataggio" @click="salva">Salva</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
// Correzione a posteriori di un elemento già completato/pagato/incassato (note e data di
// esecuzione). Il dialog non conosce l'entità: la chiamata vera la fa `azione`, fornita
// da chi lo usa (di norma una dispatch di "<modulo>/modificaCompletamento").
export default {
    name: "DialogModificaCompletamento",

    props: {
        modelValue: { type: Boolean, default: false },
        titolo: { type: String, default: "Modifica completamento" },
        sottotitolo: { type: String, default: "" },
        etichettaData: { type: String, default: "Data di esecuzione" },
        etichettaNote: { type: String, default: "Note" },
        avvisoData: { type: String, default: "" },
        // Es. manutenzioni con fermo macchina: la data non si cambia, solo le note.
        dataModificabile: { type: Boolean, default: true },
        // Valori iniziali (data in formato ISO, anche con orario: si usa solo il giorno).
        dataEsecuzione: { type: String, default: "" },
        note: { type: String, default: "" },
        // async ({ dataEsecuzione, note }) => void, lancia in caso di errore.
        azione: { type: Function, required: true },
    },
    emits: ["update:modelValue", "salvato"],

    data() {
        return {
            form: { dataEsecuzione: "", note: "" },
            salvataggio: false,
            errore: null,
        };
    },

    computed: {
        oggiIso() {
            const d = new Date();
            const m = String(d.getMonth() + 1).padStart(2, "0");
            const g = String(d.getDate()).padStart(2, "0");
            return `${d.getFullYear()}-${m}-${g}`;
        },
    },

    watch: {
        modelValue(val) {
            if (val) {
                this.form = {
                    dataEsecuzione: this.dataEsecuzione ? this.dataEsecuzione.substr(0, 10) : "",
                    note: this.note || "",
                };
                this.errore = null;
            }
        },
    },

    methods: {
        chiudi() {
            this.$emit("update:modelValue", false);
        },

        async salva() {
            if (this.dataModificabile && !this.form.dataEsecuzione) return;

            this.salvataggio = true;
            this.errore = null;
            try {
                await this.azione({
                    dataEsecuzione: this.dataModificabile ? this.form.dataEsecuzione : null,
                    note: this.form.note,
                });
                this.$emit("salvato");
                this.chiudi();
            } catch (error) {
                console.log(error);
                this.errore = (error.response && error.response.data && error.response.data.message)
                    || "Non è stato possibile salvare le modifiche. Riprova.";
            }
            this.salvataggio = false;
        },
    },
};
</script>
